import type { Rng } from "../utils/random";
import { SECTION_DEFINITIONS, INITIAL_SECTION } from "./sectionDefinitions";
import type { SectionState } from "./musicTypes";

export function createSectionState(rng: Rng): SectionState {
  const def = SECTION_DEFINITIONS[INITIAL_SECTION];
  return {
    name: INITIAL_SECTION,
    bar: 0,
    length: rng.int(def.minBars, def.maxBars),
    barsSinceChange: 0,
  };
}

/**
 * Advances one bar and switches section when the drawn length is used up.
 *
 * Transitions are a weighted choice over `allowedNext`, so the arc varies
 * between sessions while still following musical constraints (a break always
 * returns to something, intro never jumps straight to a high-energy section).
 */
export function stepSection(state: SectionState, rng: Rng): boolean {
  state.bar += 1;
  state.barsSinceChange += 1;

  if (state.bar < state.length) return false;

  const current = SECTION_DEFINITIONS[state.name];
  const candidates = current.allowedNext;
  const chosen = rng.pick(candidates, (candidate) => candidate.weight);
  const nextDef = SECTION_DEFINITIONS[chosen.section];

  state.name = chosen.section;
  state.bar = 0;
  state.length = rng.int(nextDef.minBars, nextDef.maxBars);
  state.barsSinceChange = 0;
  return true;
}
